export default "__VITE_PUBLIC_ASSET__5c82649c__"